import React from "react";
import { Button } from "reactstrap";

const CreatePlanButton = ({ onClick, isLoading = false, disabled = false }) => {
    return (
        <Button
            color="primary"
            onClick={onClick}
            size="lg"
            disabled={disabled || isLoading}
        >
            {isLoading ? (
                <>
                    <div
                        className="spinner-border spinner-border-sm mr-2"
                        role="status"
                    >
                        <span className="sr-only">Loading...</span>
                    </div>
                    Creating...
                </>
            ) : (
                <>
                    <i className="fas fa-plus mr-2" />
                    Create New Plan
                </>
            )}
        </Button>
    );
};

export default CreatePlanButton;
